import {Component, OnInit, ViewChild} from "@angular/core";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import { Observable,throwError } from 'rxjs';
import {ResetPassword} from "./ResetPassword";
import {LogService} from "../Abstract/log.service";
import {ConfigService} from "../../Core/Abstract/config.service";
import {EventsEmitterService} from "../../Core/Abstract/emitter.service";
import {PasswordValidatorOptions, passwordValidator} from "./passwordValidator.component";
import {matchOtherValidator} from "./matchOtherValidator.component";
import {ResetPasswordService} from "./resetPassword.service";
import { ActivatedRoute } from "@angular/router";
import { SecurityService } from '../../Core/Security/security.service';
import { ModalDirective } from "ngx-bootstrap/modal";

@Component({
    selector: 'resetPassword',
    templateUrl: 'resetPassword.component.html',
    providers: [ResetPasswordService]
})

export class ResetPasswordComponent implements OnInit {

    @ViewChild('msgModal',{static: false}) public msgModal: ModalDirective;
    @ViewChild('otpModal',{static: false}) public otpModal: ModalDirective;

    public email =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    private loading: boolean = false;
    private pwdmodel = {
        token:'',
        id:'',
        newPassword:'',
        username:'',
        matchNewPassword:'',

    };    
    private regexList:Array<PasswordValidatorOptions> = [];
    private rulesArray:Array<Object> = [];
    protected redirectTitle = "Something went wrong.";
    protected redirectMsg = "Data not properly provided.";

    private hasParams: boolean;
    private pwdForm: UntypedFormGroup;
    private validationMessages= {};
    private formErrors = {
        'username': '',
        'newPassword': '',
        'matchNewPassword': ''
    };
    private resetWithoutToken: boolean;
    otpForm: UntypedFormGroup;
    private validateTokenHasError:boolean = false;
    private validateTokenExpOrInvalid = "";
    private validateTokenResponse:any;


    pwderror = false;
    pwdmsg = "";
    public barLabel: string = "";
    footerMsg = "";

    constructor(private resetPasswordService: ResetPasswordService,private securityService : SecurityService, private logger: LogService, private fb: UntypedFormBuilder,
                private configService: ConfigService, private eventsEmitterService :EventsEmitterService,protected route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(
            params => {
                if(params.token){
                    this.pwdmodel.token = params.token;
                    this.validateToken();
                    // this.pwdmodel.id = params.id;
                    this.hasParams = true;    
                }else{
                    this.resetWithoutToken=true;
                    this.hasParams = false;
                }
            },
            error => {
                
               return throwError(error);
            }
        );
        // if(this.pwdmodel.token)
       this.buildForm();
       this.getRules();
       this.footerMsg = this.configService.getFooter();
    }

    protected getRules(): void {
        this.resetPasswordService.getRules().subscribe(
            data => {
                this.logger.log(data);
                this.rulesArray = data;
                this.rulesArray.forEach(rule => {
                    //this.logger.log(rule);
                    if(rule['regex'] != null && rule['regex'] != ''){
                        this.regexList.push(new PasswordValidatorOptions(new RegExp(rule['regex']), rule['name']));
                    }
                });
                
            },
            error => {
                this.logger.log("Could not get pass rules!");
                this.resetPasswordService.goToLogin();
            }
        );
    }

    private buildForm() {
        this.otpForm = new UntypedFormGroup({
            'otp': new UntypedFormControl(null, [Validators.required])
        });
        this.pwdForm = this.fb.group({
            'username': [{value: this.pwdmodel.username, disabled: true}, [Validators.required, Validators.pattern(this.email)]],
            'token': [this.pwdmodel.token],
            'id': [this.pwdmodel.username],
            'newPassword': [this.pwdmodel.newPassword, [Validators.required, passwordValidator(this.regexList)]],
            'matchNewPassword': [this.pwdmodel.matchNewPassword, [Validators.required, matchOtherValidator('newPassword')]]
        })

        this.validationMessages = {
            'username': {
                'required': 'Required field',
                'pattern': 'Please provide a valid email.'
            },
            'newPassword': {
                'required': 'Required field',  
            },
            'matchNewPassword': {
                'required': 'Required field',
                'matchOther': 'Passwords do not match'
            }
        };

        this.pwdForm.valueChanges.subscribe(data => this.onValueChanged(data));

        this.onValueChanged();
    }

    /*
     *  Different impl with formErrors as Array<string>
     */
    onValueChanged(data?: any) {
        if (!this.pwdForm) { return; }
        
        //set custom regex visuals here
        //cannot move this in build form, messages are empty 
        this.rulesArray.forEach(rule => {
            if(rule['regex'] != null && rule['regex'] != ''){
                this.validationMessages['newPassword'][rule['name']] = rule['message'] || 'Password not matching criteria';
                this.validationMessages['newPassword'][rule['name']] = rule['message'] || 'Password not matching criteria';
            }
        });

        const form = this.pwdForm;
        //this.logger.log(this.pwdForm);
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = [];
            const control = form.get(field);

            if (control && control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                //this.logger.log(control.errors)
                for (const key in control.errors) {
                    this.formErrors[field].push(messages[key]);
                }
            }
        }
        // this.logger.log("formerrors: " + JSON.stringify(this.formErrors));
    }

    public returnToLogin(){
        this.resetPasswordService.goToLogin();
    }

    public doResetPassword(pwdmodel: ResetPassword){
        this.loading = true;
        this.pwderror = false;
        this.resetPasswordService.resetPasswordRequest(pwdmodel).subscribe(
            data => {
                if(data.success){
                    this.securityService.goToLogin("resetPassword","true");
                }else{
                    LogService.emitAlert({
                        type: "danger",
                        body: data.message
                      });
                }

                this.loading = false;
            },
            error => {
                this.loading = false;
                this.pwderror = true;
                this.pwdmsg = error.message;

                this.logger.error(error);
                return throwError(error);
            }
            
        );
    }

    openOtpModal(){
        this.otpForm.reset();
        this.showOptModal();
    }

    public showChildModal(): void {
        this.msgModal.show();
    }

    public hideChildModal(): void {
        this.msgModal.hide();
    }

    public showOptModal(): void {
        this.otpModal.show();
    }

    public hideOptModal(): void {
        this.otpModal.hide();
    }

    submitOtp(){
        this.pwdmodel.token = this.otpForm.value.otp;
        this.validateToken();
    }
    validateToken(){
        this.loading = true;
        this.resetPasswordService.validateToken(this.pwdmodel.token).subscribe(
            data => {
                this.validateTokenResponse = JSON.parse(data);
                this.loading = false;
                if(this.validateTokenResponse.message == 'valid'){
                    this.pwdmodel.username=this.validateTokenResponse.data;
                    this.pwdmodel.id=this.validateTokenResponse.data;
                    this.validateTokenHasError = false;
                    this.resetWithoutToken=false;
                    this.hasParams = true;
                }
                else if(this.validateTokenResponse.message == 'expired'){
                    this.validateTokenHasError = true
                    this.validateTokenExpOrInvalid = 'EXP';
                    this.redirectTitle = 'Your token has expired';
                    this.redirectMsg = 'Resend Verification Mail!';
                    this.showChildModal();
                }
               else if(this.validateTokenResponse.message == 'invalidToken'){ 
                this.validateTokenHasError = true
                this.validateTokenExpOrInvalid = 'INV'
                this.redirectTitle = 'Your token is invalid';
                this.redirectMsg = 'Your token is invalid';
                this.showChildModal();
               }
               this.hideOptModal();
            },
            error => {
                this.validateTokenHasError = true;
                this.redirectTitle = 'Something went wrong.';
                this.redirectMsg = ''
                this.loading = false;
                this.logger.log("Could not get pass rules!");
            }
        );
    }
}